import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

interface Props {
  title: string;
}

function ExperienceTitle({ title }: Props) {
  return (
    <Typography
      className="cursor-pointer text-gray-800"
      tabIndex={0}
      variant="subtitleMedium"
      as="h5"
      fontWeight="medium"
    >
      {title}
    </Typography>
  );
}
export default observer(ExperienceTitle);
